import React from 'react';

const LightingIcon = ({ color = '#0F7F85', width = 24, height = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12.0001 12V18M4.07708 10.615C4.01369 10.767 3.9888 10.9323 4.00463 11.0962C4.02047 11.2601 4.07654 11.4175 4.16786 11.5546C4.25918 11.6916 4.38292 11.8039 4.52811 11.8817C4.67329 11.9594 4.83541 12 5.00008 12H19.0001C19.1648 12 19.3269 11.9594 19.4721 11.8817C19.6172 11.8039 19.741 11.6916 19.8323 11.5546C19.9236 11.4175 19.9797 11.2601 19.9955 11.0962C20.0114 10.9323 19.9865 10.767 19.9231 10.615L16.8461 3.231C16.6943 2.8665 16.4379 2.5551 16.1094 2.33604C15.7809 2.11697 15.3949 2.00005 15.0001 2H9.00008C8.60535 1.99997 8.21943 2.11674 7.89093 2.33562C7.56244 2.5545 7.30606 2.86569 7.15408 3.23L4.07708 10.615ZM8.00008 20C8.00008 19.4696 8.2108 18.9609 8.58587 18.5858C8.96094 18.2107 9.46965 18 10.0001 18H14.0001C14.5305 18 15.0392 18.2107 15.4143 18.5858C15.7894 18.9609 16.0001 19.4696 16.0001 20V21C16.0001 21.2652 15.8947 21.5196 15.7072 21.7071C15.5197 21.8946 15.2653 22 15.0001 22H9.00008C8.73487 22 8.48051 21.8946 8.29298 21.7071C8.10544 21.5196 8.00008 21.2652 8.00008 21V20Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LightingIcon;
